module.exports = __webpack_public_path__ + "img/12.27d7a63a.jpg";